//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vux/src/components/cell-form-preview/index.vue